import { Controller } from '@hotwired/stimulus'

// Shows a window.confirm prompt before allowing a chained action to run.
// Usage:
//   data-controller="confirm-action"
//   data-confirm-action-message-value="Are you sure?"
//   data-action="click->confirm-action#check click->other-controller#doThing"
//
// The check action runs first; if the user cancels, subsequent actions in the
// chain are blocked via stopImmediatePropagation.
export default class extends Controller {
  static values = { message: String }

  check(event) {
    if (!window.confirm(this.messageValue)) {
      event.preventDefault()
      event.stopImmediatePropagation()
    }
  }
}
